'use strict';
var trackingUtils = require('../utils/tracking.utils.js');
var Modal;
var HEADER_CLASS = 'modal_header';
var CONTAINER_CLASS = 'modal_container';
var FOOTER_CLASS = 'modal_footer';
var FOOTER_BUTTON_CLASS = 'modal_button';
var CLOSE_BUTTON_CLASS = 'modal_close';
var OPEN_CLASS = 'open';
var MODAL_LAYER = '.' + CONTAINER_CLASS + '.' + OPEN_CLASS;
var OVERFLOW_HIDDEN_CLASS = 'odf-overflow-hidden';
var LOCK_BODY_SELECTOR = 'body';

var closeOnOutclickHandler = function(e) {
    var $target = $(Odigeo._.get(e, 'target'));
    if ($target.hasClass(CONTAINER_CLASS)) {
        $(MODAL_LAYER).off(Odigeo.Events.tap, this.CLOSE_OUTCLICK_HANDLER);
        this.close(true);
    }
};

var trackModalEvent = function(tracking) {
    if (!Odigeo._.isEmpty(tracking.action) && !Odigeo._.isEmpty(tracking.label)) {
        trackingUtils.trackEvent(tracking.action, tracking.label, tracking.page);
    }
};

/*
 * @param {WebElement} container - Container where modal is going to be created
 * @param {Object} content - Content for text in modal
 * @param {string} content.header - Header translation
 * @param {string} content.content - Modal content translation
 * @param {string} content.button - Footer button translation
 * @param {Object} options - Options
 * @param {true} options.displayButtonFooterAtInit - Display button initially
 */
Modal = function(container, content, options) {
    this.CLOSE_OUTCLICK_HANDLER = Odigeo._.bind(closeOnOutclickHandler, this);
    this.$container = (container instanceof $) ? container : $(container);
    this.content = Odigeo._.extend({
        header: '',
        content: '',
        button: '',
        constants: {
            containerClass: CONTAINER_CLASS,
            closeButtonClass: CLOSE_BUTTON_CLASS,
            footerClass: FOOTER_CLASS,
            footerButtonClass: FOOTER_BUTTON_CLASS,
            headerClass: HEADER_CLASS,
        },
    }, content);
    this.options = Odigeo._.merge({
        template: null,
        fillThePage: true,
        generateHtml: true,
        preventContainerTap: true,
        button: {
            hide: false,
            callback: function() {
            },
            analytics: {
                action: '',
                label: '',
            },
        },
        open: {
            analytics: {
                action: '',
                label: '',
            },
        },
        close: {
            analytics: {
                action: '',
                label: '',
            },
        },
    }, options);

    if (this.options.generateHtml) {
        return this.initTemplate()
            .then(Odigeo._.bind(function(modal) {
                this.generateTemplate();
                this.bindEvents();
                return modal;
            }, this));
    } else {
        this.bindEvents();
        return Promise.resolve(this);
    }
};

Modal.prototype.initTemplate = function() {
    if (!Odigeo._.isFunction(this.options.template)) {
        return Odigeo.Templates.getGenericTemplates(['modal'])
            .then(Odigeo._.bind(function(templates) {
                this.options.template = Odigeo._.get(templates, 'modal.modal', Odigeo._.noop);
                return this;
            }, this));
    } else {
        return Promise.resolve(this);
    }
};

Modal.prototype.generateTemplate = function() {
    var templateBuilder = this.options.template || Odigeo._.noop;
    var $modalEl = $(templateBuilder(this.content));

    var modalMaxHeigh = this.options.fillThePage ? 'calc(100vh - 20px)' : undefined;
    $modalEl.css({
        'max-height': modalMaxHeigh,
        'overflow': 'hidden',
    });

    this.$container.addClass('odf-lightbox-bg modal_lightbox')
        .empty()
        .append($modalEl);
};

Modal.prototype.updateContainer = function($container) {
    if ($container instanceof $) {
        this.$container = $container;
        this.generateTemplate();
        this.bindEvents();
    }
};

Modal.prototype.bindEvents = function() {
    if (this.options.preventContainerTap) {
        this.$container.on(Odigeo.Events.tap, function(evt) {
            evt.stopPropagation();
            evt.preventDefault();
        });
    }

    this.$container.find('.' + FOOTER_BUTTON_CLASS).on(Odigeo.Events.tap, Odigeo._.bind(function(evt) {
        evt.stopPropagation();
        evt.preventDefault();
        trackModalEvent(this.options.button.analytics);

        this.$container.one(Odigeo.Events.transitionEnd, Odigeo._.bind(function() {
            var callback = Odigeo._.get(this.options, 'button.callback');
            if (Odigeo._.isFunction(callback)) {
                callback();
            }
        }, this));
        this.close(false);
    }, this));

    this.$container.find('.' + CLOSE_BUTTON_CLASS).on(Odigeo.Events.tap, Odigeo._.bind(function(evt) {
        evt.stopPropagation();
        evt.preventDefault();
        this.close(true);
    }, this));
};

Modal.prototype.open = function(showButton, closeOnOutclick) {
    showButton = showButton && !Odigeo._.get(this.options, 'button.hide', false);
    this.$container.find('.' + FOOTER_CLASS).toggleClass('odf-hidden', Odigeo._.isUndefined(showButton) || !showButton);
    this.$container.addClass(OPEN_CLASS);
    this.toggleLockBody(true);
    trackModalEvent(this.options.open.analytics);
    if (closeOnOutclick) {
        this.closeOnOutclick();
    }
};

Modal.prototype.close = function(trackEvent) {
    this.$container.removeClass(OPEN_CLASS);
    this.toggleLockBody(false);
    if (trackEvent) {
        trackModalEvent(this.options.close.analytics);
    }
};

Modal.prototype.closeOnOutclick = function() {
    $(MODAL_LAYER).on(Odigeo.Events.tap, this.CLOSE_OUTCLICK_HANDLER);
};

Modal.prototype.toggleLockBody = function(lock) {
    $(LOCK_BODY_SELECTOR).toggleClass(OVERFLOW_HIDDEN_CLASS, lock);
};

module.exports = Modal.prototype.constructor = Modal;
